export enum AIRulesMonitoring {
    showAI = 'AI_Rule_Icon',
    submitBtn = 'AI_Rule_GO_Clicks',
    aiNoResult = 'AI_Rule_No_Results',
    aiRuleSave = 'AI_Rule_Save'
}
